module.exports = function() { throw new Error("define cannot be used indirect"); };



//////////////////
// WEBPACK FOOTER
// ../~/webpack/buildin/amd-define.js
// module id = ../node_modules/webpack/buildin/amd-define.js
// module chunks = 0